var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"mt-7",staticStyle:{"background-color":"#F9F9FC"}},[_c('h2',[_vm._v("Monthly Active Shipment")]),_c('TableuVue',{attrs:{"width":_vm.width,"url":_vm.url}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }